module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-list"
  }, _vm._l((_vm.requirementList), function(requirement) {
    return _c('div', {
      staticClass: "work-progress"
    }, [_c('el-row', {
      staticClass: "base-info"
    }, [_c('el-col', {
      staticClass: "cover-wrapper",
      attrs: {
        "span": 6
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": ("" + _vm.UPLOAD_IMG_HOST + (requirement.bookRequirement.coverPath))
      }
    })]), _vm._v(" "), _c('el-col', {
      staticClass: "content-wrapper",
      attrs: {
        "span": 12
      }
    }, [_c('el-row', {
      staticClass: "book-name-col"
    }, [_c('span', {
      staticClass: "book-name"
    }, [_vm._v(_vm._s(requirement.bookRequirement.requirementName))]), _vm._v(" "), _c('span', {
      staticClass: "work-status"
    }, [_vm._v(_vm._s(_vm.getRequirementStatus(requirement.bookRequirement.requirementViewStatus)))])]), _vm._v(" "), _c('el-row', {
      staticClass: "anchor-share-pay-col"
    }, [(requirement.bookRequirement.pay.royaltyShareRatio && !requirement.bookRequirement.pay.prePay) ? _c('span', {
      staticClass: "share-label"
    }, [_vm._v(_vm._s(_vm.$t('word.sharePay')) + " ")]) : _vm._e(), _vm._v(" "), (requirement.bookRequirement.pay.prePay && !requirement.bookRequirement.pay.royaltyShareRatio) ? _c('span', {
      staticClass: "share-label"
    }, [_vm._v(_vm._s(_vm.$t('word.basePrice')))]) : _vm._e(), _vm._v(" "), (requirement.bookRequirement.pay.prePay && requirement.bookRequirement.pay.royaltyShareRatio) ? _c('span', {
      staticClass: "share-label"
    }, [_vm._v(_vm._s(_vm.$t('word.basePrice')) + " + " + _vm._s(_vm.$t('word.sharePay')))]) : _vm._e(), _vm._v(" "), (requirement.bookRequirement.pay.royaltyShareRatio) ? _c('span', [_vm._v(_vm._s(Math.round(requirement.bookRequirement.pay.royaltyShareRatio * 100)) + "%")]) : _vm._e(), _vm._v(" "), (requirement.bookRequirement.pay.royaltyShareRatio && requirement.bookRequirement.pay.prePay) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(" "), (requirement.bookRequirement.pay.prePay) ? _c('span', [_vm._v(_vm._s(requirement.bookRequirement.pay.prePay.direct.multiplier) + _vm._s(requirement.bookRequirement.pay.prePay.unit))]) : _vm._e()]), _vm._v(" "), _c('el-row', [_c('pre', [_vm._v(_vm._s(_vm.$t('comb.taskCategory')) + ":  " + _vm._s(requirement.bookRequirement.categoryLabel))])]), _vm._v(" "), (requirement.bookRequirement.requirement) ? _c('el-row', [_c('pre', [_vm._v(_vm._s(_vm.$t('comb.taskRequirement')) + ":  " + _vm._s(requirement.bookRequirement.requirement))])]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('pre', [_vm._v(_vm._s(_vm.$t('comb.recruitmentAmount')) + ":  " + _vm._s(requirement.bookRequirement.userCount))])]), _vm._v(" "), _c('el-row', [_c('pre', [_vm._v(_vm._s(_vm.$t('comb.releaseMode')) + ":  " + _vm._s(requirement.bookRequirement.demandDistributionOption))])])], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "time-line-wrapper"
    }, [_c('el-steps', {
      attrs: {
        "space": 130,
        "align-center": true
      }
    }, _vm._l((requirement.bookRequirement.timeNodeList), function(node) {
      return _c('el-step', {
        attrs: {
          "description": _vm.getEvent(node.event, node.message),
          "title": _vm.formatDate(node.time)
        }
      })
    }))], 1), _vm._v(" "), (requirement.requirementAlbum) ? _c('el-row', {
      staticClass: "task-wrapper"
    }, [_c('el-col', {
      staticClass: "task-info",
      attrs: {
        "xs": 8,
        "sm": {
          span: 5,
          offset: 1
        },
        "md": {
          span: 5,
          offset: 1
        },
        "lg": {
          span: 5,
          offset: 1
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.transcribed')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(requirement.requirementAlbum.trackCount))])]), _vm._v(" "), _c('el-col', {
      staticClass: "task-info",
      attrs: {
        "xs": 8,
        "sm": {
          span: 5,
          offset: 1
        },
        "md": {
          span: 5,
          offset: 1
        },
        "lg": {
          span: 5,
          offset: 1
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.buyAmount')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(requirement.requirementAlbum.subscribeCount))])]), _vm._v(" "), _c('el-col', {
      staticClass: "task-info",
      attrs: {
        "xs": 8,
        "sm": {
          span: 5,
          offset: 1
        },
        "md": {
          span: 5,
          offset: 1
        },
        "lg": {
          span: 5,
          offset: 1
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.played')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(requirement.requirementAlbum.playCount))])])], 1) : _vm._e(), _vm._v(" "), (requirement.requirementAnchor) ? _c('el-row', {
      staticClass: "anchor-list"
    }, [_c('span', {
      staticClass: "list-label"
    }, [_vm._v(_vm._s(_vm.$t('word.anchor')))]), _vm._v(" "), _c('el-row', {
      staticClass: "anchor"
    }, [_c('img', {
      attrs: {
        "src": _vm.getHeaderPic(requirement.requirementAnchor.headPic)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('a', {
      attrs: {
        "href": _vm.getHref(requirement.requirementAnchor.userId)
      }
    }, [_vm._v(_vm._s(requirement.requirementAnchor.nickname))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('comb.goodAt')) + "："), _vm._l((requirement.requirementAnchor.skills), function(skill) {
      return _c('b', [_vm._v(" " + _vm._s(skill) + " ")])
    })], 2)])])], 1) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-578e4a0b!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/WorkProgress.vue
// module id = 1020
// module chunks = 0